jQuery(document).ready(function ($) {
	$('.clickable').on('click', function () {
		window.location.href = $(this).find('a').attr('href');
	});
});